// extracted by mini-css-extract-plugin
export default {"shortcutItemsWrapper":"shortcutContainer_shortcutItemsWrapper__O4QPU","shortcutWrapper":"shortcutContainer_shortcutWrapper__IiyaX"};